<template>
  <div class="flex flex-col items-center bg-[rgba(255,255,255,0.50)] backdrop-blur-[7.5px]">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span class="v3-body-regular-400-line-height-auto p-[24px] text-[--v3-global-textsecondarycolor]" v-html="message" />
    <div class="flex gap-[12px] px-[24px] pb-[24px] pt-[12px]">
      <Button
        outlined
        severity="secondary"
        label="Cancel"
        :disabled="loading"
        @click="$emit('cancel')"
      />
      <Button
        severity="danger"
        label="Confirm"
        icon="trash"
        icon-class="size-[14px]"
        icon-align="right"
        :loading
        @click="$emit('confirm')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import Button from '@/common/components/atoms/Button';

const props = withDefaults(defineProps<{
  list: string,
  keyword: string | undefined | null,
  loading?: boolean,
}>(), {
  loading: false,
});

defineEmits<{
  cancel: [],
  confirm: [],
}>();

const message = computed<string>(() => {
  if (props.keyword) {
    return `Are you sure you want to remove keyword <strong>"${props.keyword}"</strong> from list <strong>“${props.list}”</strong>?`;
  }

  return `Are you sure you want to delete list <strong>“${props.list}”</strong>?`;
});
</script>

<style scoped>
/* Add your styles here */
</style>
